"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ModalContainer = exports.MessagesWrapper = exports.IconWrapper = exports.IconTextWrapper = exports.Footer = exports.Container = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__Wrapper",
  componentId: "sc-3ixyf3-0"
})(["display:flex;justify-content:center;width:100%;"]);
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__Container",
  componentId: "sc-3ixyf3-1"
})(["display:flex;justify-content:left;flex-direction:column;padding:", " ", " ", " ", ";"], _ref => {
  let {
    isTextLeftAlign
  } = _ref;
  return isTextLeftAlign ? _uiKit.theme.spacing.BASE_1 : _uiKit.theme.spacing.BASE_10;
}, _uiKit.theme.spacing.BASE_1, _uiKit.theme.spacing.BASE_10, _uiKit.theme.spacing.BASE_1);
const Footer = exports.Footer = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__Footer",
  componentId: "sc-3ixyf3-2"
})(["display:flex;width:100%;justify-content:end;button{margin-left:", ";&:first-child{margin-left:0;}}"], _uiKit.theme.spacing.BASE_2);
const IconWrapper = exports.IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__IconWrapper",
  componentId: "sc-3ixyf3-3"
})(["position:relative;margin:0 auto;"]);
const MessagesWrapper = exports.MessagesWrapper = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__MessagesWrapper",
  componentId: "sc-3ixyf3-4"
})(["display:flex;align-items:center;flex-direction:column;text-align:", ";> div{display:flex;align-items:center;line-height:22px;letter-spacing:", ";font-size:", ";padding-top:", ";}b{font-weight:", ";}"], _ref2 => {
  let {
    isTextLeftAlign
  } = _ref2;
  return isTextLeftAlign ? 'left' : 'center';
}, _uiKit.theme.fonts.letterSpacing.LARGE, _uiKit.theme.fonts.size.LARGE, _uiKit.theme.spacing.BASE_2, _uiKit.theme.fonts.weight.BOLD);
const IconTextWrapper = exports.IconTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__IconTextWrapper",
  componentId: "sc-3ixyf3-5"
})(["display:flex;flex-direction:row;align-self:flex-start;"]);
const ModalContainer = exports.ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "AlertingBannerModalstyle__ModalContainer",
  componentId: "sc-3ixyf3-6"
})(["position:absolute;top:-200px;"]);